<template>
  <div>
    <Input type="text" v-model.trim="editList[colKey]" v-if="editIndex === index"/>
    <span v-else>
      {{ this.title.search(/￥/) !== -1 ? '￥' : '' }}
      {{ colValue[colKey] }}
    </span>
  </div>
</template>
<script>
export default {
  name: "tableListUnit",
  components: {},
  props: {
    editList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    editIndex: {
      type: Number,
      default: -1,
    },
    index: {
      type: Number,
      default: -1,
    },
    colKey: {
      type: String,
      default: "",
    },
    colValue: {
      type: Object,
      default: () => {
        return {};
      },
    },
    title: {
      type: String,
      default: "title",
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>